// Utilities
import { createSimpleFunctional } from '@/util'

export const VCardSubtitle = createSimpleFunctional('v-card-subtitle')

export type VCardSubtitle = InstanceType<typeof VCardSubtitle>
